import Vue from 'vue'
import formatter from '../format.helper'
import mime from 'mime-types'
import vSelect from 'vue-select'
import multiSelect from 'vue-multi-select'
import 'vue-multi-select/dist/lib/vue-multi-select.min.css'
import VueApexCharts from 'vue-apexcharts'
import Lightbox from 'vue-pure-lightbox'
import Money from '@/components/_partial/money/component'
import * as Vue2Leaflet from 'vue2-leaflet'
import * as VueGoogleMaps from 'vue2-google-maps'

import 'leaflet/dist/leaflet.css'

Vue.component('l-map', Vue2Leaflet.LMap)
Vue.component('l-tilelayer', Vue2Leaflet.LTileLayer)
Vue.component('l-marker', Vue2Leaflet.LMarker)
Vue.use(Lightbox)
Vue.component('apexcharts', VueApexCharts)
Vue.component('v-select', vSelect)
Vue.component('multi-select', multiSelect)
Vue.use(Money, { precision: 2, decimal: ',', thousands: '.', prefix: '', suffix: '', masked: false })
Vue.component('money', Money)

Vue.use(VueGoogleMaps, {
  load: {
    key: Vue.config.env.VUE_APP_GOOGLE_MAP_KEY
  }
})

Vue.config.dateRangePicker = {
  'template': '<div class="daterangepicker dropdown-menu"><div class="panel panel-flat"><div class="panel-body"><div class="row"><div class="col-sm-12">' +
    '<div class="calendars">' +
    '<div class="calendar left">' +
    '<div class="calendar-table"></div>' +
    '<div class="daterangepicker_input">' +
    '<span class="start-date-label"></span>' +
    '<input class="form-control" type="text" name="daterangepicker_start" value="" />' +
    '<i class="icon-calendar3"></i>' +
    '<div class="calendar-time">' +
    '<div></div>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '<div class="calendar right">' +
    '<div class="calendar-table"></div>' +
    '<div class="daterangepicker_input">' +
    '<span class="end-date-label"></span>' +
    '<input class="form-control" type="text" name="daterangepicker_end" value="" />' +
    '<i class="icon-calendar3"></i>' +
    '<div class="calendar-time">' +
    '<div></div>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '</div></div></div><div class="row"><div class="col-sm-12">' +
    '<div class="ranges">' +
    '<div class="range_inputs">' +
    '<button class="applyBtn" disabled="disabled" type="button" style="display: inline-block;"></button> ' +
    '<button class="cancelBtn" type="button" style="display: inline-block;"></button>' +
    '</div>' +
    '</div>' +
    '</div></div></div></div></div>'
}

Vue.config.statuses = [
  'Deleted', // 0
  'Active', // 1
  'Inactive', // 2
  'Pending', // 3
  'Rejected', // 4
  'Done', // 5
  'Paid', // 6
  'Paid partially', // 7
  'Received', // 8
  'Received partially', // 9
  'Sent', // 10
  'Not sent' // 11
]

Vue.config.statusMap = {
  'bg-violet-300': 11,
  'bg-violet-500': 10,
  'bg-slate-300 border-bottom-slate-700': 9,
  'bg-slate-600': 8,
  'bg-indigo-300 border-bottom-indigo-700': 7,
  'bg-indigo-600': 6,
  'bg-teal-400': 5,
  'bg-warning-400': 4,
  'bg-orange-400': 3,
  'label-danger': 2,
  'label-success': 1,
  'bg-grey-400': 0
}

Vue.config.statusGroups = {
  '*': [1, 2, 0],
  'project': [1, 2, 0],
  'apartment': [1, 2, 3, 0]
}

Vue.prototype.$formatter = formatter
Vue.prototype.$mime = mime

/**
 * @todo: replace this shitty ($containerHeight) jQuery coding with VueJS native...
 */
Vue.prototype.$containerHeight = () => {
  // eslint-disable-next-line
  let availableHeight = $(window).height() - $('.page-container').offset().top - $('.navbar-fixed-bottom').outerHeight()
  // eslint-disable-next-line
  $('.page-container').attr('style', 'min-height:' + availableHeight + 'px')
}

/**
 * @todo: replace this shitty ($adjustHandlers) jQuery coding with VueJS native...
 */
Vue.prototype.$adjustHandlers = () => {
  // Hide if collapsed by default
  // eslint-disable-next-line
  $('.category-collapsed').children('.category-content').hide()
  // Rotate icon if collapsed by default
  // eslint-disable-next-line
  $('.category-collapsed').find('[data-action=collapse]').addClass('rotate-180')
  // Collapse on click
  // eslint-disable-next-line
  $(document).off('click', '.category-title [data-action=collapse]').on('click', '.category-title [data-action=collapse]', (e) => {
    e.preventDefault()
    // eslint-disable-next-line
    let $categoryCollapse = $(e.target).parent().parent().parent().next()
    // eslint-disable-next-line
    $(e.target).parents('.category-title').toggleClass('category-collapsed')
    // eslint-disable-next-line
    $(e.target).toggleClass('rotate-180')
    $categoryCollapse.slideToggle(150)
    // Vue.$containerHeight() // adjust page height
  })
}

Vue.prototype.$stylify = () => {
  // Styled checkboxes/radios
  /* $('.styled').uniform({
    radioClass: 'choice'
  }) */
  $(document).off('click', '.navicon').on('click', '.navicon', function () {
    $('.nav-new').animate({
      width: 'toggle'
    })
  })
}

Vue.prototype.$getMimeIcon = (lookup) => {
  let type = Vue.prototype.$mime.lookup(lookup)
  let $iconClasses = {
    // Media
    'image':
      'file-image',
    'audio':
      'file-audio',
    'video':
      'file-video',
    // Documents
    'application/pdf':
      'file-pdf',
    'application/msword':
      'file-word',
    'application/vnd.ms-word':
      'file-word',
    'application/vnd.oasis.opendocument.text':
      'file-word',
    'application/vnd.openxmlformats-officedocument.wordprocessingml':
      'file-word',
    'application/vnd.ms-excel':
      'file-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml':
      'file-excel',
    'application/vnd.oasis.opendocument.spreadsheet':
      'file-excel',
    'application/vnd.ms-powerpoint':
      'file-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml':
      'file-powerpoint',
    'application/vnd.oasis.opendocument.presentation':
      'file-powerpoint',
    'text/plain':
      'file-text',
    'text/html':
      'file-code',
    'application/json':
      'file-code',
    // Archives
    'application/gzip':
      'file-archive',
    'application/zip':
      'file-archive'
  }
  for (let t in $iconClasses) {
    if (type.search(new RegExp(t))) {
      return $iconClasses[t]
    }
  }
  return 'file'
}

Vue.filter('nl2br', function (value) {
  return value.replace(/\r/g, '').replace(/\n+/g, '\n').replace(/\n/g, '<br />')
})

require('vue-image-lightbox/dist/vue-image-lightbox.min.css')
require('vue-on-toast/dist/vue-on-toast.css')
